import EditRadio from './EditRadio.vue'
import EditCheckbox from './EditCheckbox.vue'
import EditSection from './EditSection.vue'
import EditBlank from './EditBlank.vue'
import EditBlank_multiple from './EditBlankMultiple.vue'
import  EditDropdown_single from './EditDropdownSingle.vue'
import  EditDropdown_multiple from './EditDropdownMultiple.vue'
import  EditSelect_multiple from './EditSelectMultiple.vue'
import  EditImage_single from './EditImageSingle.vue'
import  EditImage_multiple from './EditImageMultiple.vue'
import  EditScale from './EditScale.vue'
import  EditSort from './EditSort.vue'
import  EditMatrix_scale from './EditMatrixScale.vue'
import  EditProportion from './EditProportion.vue'
import  EditFile from './EditFile.vue'
import  EditDate from './EditDate.vue'
import  EditAddress from './EditAddress.vue'
import  EditAutograph from './EditAutograph.vue'
export default {
    EditRadio,
    EditCheckbox,
    EditSection,
    EditBlank,
    EditBlank_multiple,
    EditDropdown_single,
    EditDropdown_multiple,
    EditSelect_multiple,
    EditImage_single,
    EditImage_multiple,
    EditScale,
    EditSort,
    EditMatrix_scale,
    EditProportion,
    EditFile,
    EditDate,
    EditAddress,
    EditAutograph
}